import { Component, OnInit,Input,ViewChild} from '@angular/core';
import { ControlEncuesService } from "./control-encues.service";
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { lang_controlEncues } from 'app/idiomas/i18n/control-encues/control-encues.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import {MatTableDataSource} from '@angular/material/table';
import Swal from 'sweetalert2';
import *  as $ from 'jquery';
import { MatSnackBar } from "@angular/material/snack-bar";
import {MatSort} from '@angular/material/sort';
@Component({
  selector: 'app-control-encues',
  templateUrl: './control-encues.component.html',
  styleUrls: ['./control-encues.component.scss']
})
export class ControlEncuesComponent implements OnInit {
    @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = ['name','type_survey', 'start_date', 'id_status','token_config','HC','Respuestas','end_date','prorroga','reporte_excel','online','offline','auditoria','sector','subsector','emailResponsable','project_manager'];
  dataSource: MatTableDataSource<any>;
  selectedInstituto: string="";
  selectedYears: string="";
  selectedProduc: string="";
  selectedEsta: string="";
  institutes : any;
  years : any;
  Productos:any;
  cargando=true;

  Estatus= [
     {value: '1', viewValue: 'Activa'},
     {value: '2', viewValue: 'Cerrada'},
   ];
  historyEventReport= [
     {user: 'andres@localhost.com.mx', date: '13-23-23', tipo:1, event:0},
     {user: 'Berenice@localhost.com.mx', date: '14-23-23', tipo:1, event:1},
     {user: 'Alejandro bb@localhost.com.mx ', date: '15-23-23', tipo:1, event:0},
     {user: 'x@localhost.com.mx', date: '16-23-23', tipo:1, event:1},
   ];


   filtroAbierto=true;
   busquedaIniciada:boolean=false;
  constructor(
    private controlSurvey: ControlEncuesService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translate: TranslateService,
    private snackBar: MatSnackBar,

  ) {
    lang_perfiles.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_controlEncues.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
   }

  ngOnInit(): void {

this.getInstitutos();
this.getYears();
this.getProducts();
  }

  filtrarInformacion(){
    this.busquedaIniciada=true;
this.filtroAbierto=false;
this.cargando=true;
let datos={
  broker:this.selectedInstituto,
  year:this.selectedYears,
  typeSurvey:this.selectedProduc,
  idStatus:this.selectedEsta,
}
// console.log('selectedInstituto',this.selectedInstituto);
// console.log('selectedYears',this.selectedYears);
// console.log('selectedProduc',this.selectedProduc);
// console.log('selectedEsta',this.selectedEsta);

this.controlSurvey.getControlEncuestaItbm(datos).subscribe((respuesta:any) => {
  console.log('respuesta',respuesta);
  respuesta.records.forEach((status,i) => {
    // status.ReporteExcelText2=this.historyEventReport;
    if (status.ReporteExcelText!=null) {
      const conc= `[${status.ReporteExcelText.replaceAll(':\"','\":')}]`;
  const objetoHistorial=JSON.parse(conc);
  console.log('objetoHistorial',objetoHistorial);
  status.ReporteExcelText2=objetoHistorial;
    }
    if (status.AuditoríaText!=null) {
      const conc= `[${status.AuditoríaText.replaceAll(':\"','\":')}]`;
  const objetoHistorial=JSON.parse(conc);
  console.log('objetoHistorial',objetoHistorial);
  status.AuditoríaText2=objetoHistorial;
    }
    if (status.OfflineText!=null) {
      const conc= `[${status.OfflineText.replaceAll(':\"','\":')}]`;
  const objetoHistorial=JSON.parse(conc);
  console.log('objetoHistorial',objetoHistorial);
  status.OfflineText2=objetoHistorial;
    }
    if (status.OnlineText!=null) {
      const conc= `[${status.OnlineText.replaceAll(':\"','\":')}]`;
  const objetoHistorial=JSON.parse(conc);
  console.log('objetoHistorial',objetoHistorial);
  status.OnlineText2=objetoHistorial;
    }

  });
  this.dataSource = new MatTableDataSource<any>(respuesta.records);
// console.log('this.dataSource',this.dataSource);
setTimeout(() => {
  this.dataSource.sort = this.sort;
}, 1000);
  // $("#PrincipalSpan").off("click");

this.cargando=false;

})
  }

  getInstitutos(){
    this.controlSurvey.getInstitutos().subscribe((respuesta:any) => {
      console.log("getInstitutos:",respuesta);
      if(respuesta.success){
this.institutes=respuesta.Institutos;
      }
    });
  }

 getYears() {
    this.controlSurvey.getYearsArray().subscribe((response: any) => {
      console.log("años asignados::::::",response);
      this.years = response.anios;
    }, error => {
      console.log("error", error);
    });
  }

  private getProducts() {
    let productSurvey:any[]=[];

    this.controlSurvey.getProductsArray().subscribe((respuesta: any) => {
      console.log("Respuestas productos",respuesta);
      respuesta.productos.forEach(producto => {
        switch (producto.idProducto) {
          case 1: case 2:case 3:case 4:case 6:case 8:case 9:case 10:case 11:case 12:case 13:case 14:case 15:case 16:case 19:case 20: case 28: case 29: case 30: case 31: case 32: case 33: case 37: case 38: case 39: case 40: case 41: case 42: case 43: case 44: case 45: case 46: case 47: case 48: case 49: case 50: case 51: case 52:  case 55: case 56: case 57: case 58: case 59:
          productSurvey.push(producto);
            break;

          default:
            break;
        }
  });
  this.Productos=productSurvey;
  console.log('Productos',this.Productos);

  }, error => {
    console.log("error", error);
  });
  }

  reporte_excel(event: any,element:any,index:number,opcion:number){
  console.log('element reporte_excel',element);
  console.log('index reporte_excel',index);
  console.log('opcion reporte_excel',opcion);
  console.log('event reporte_excel',event);
  Swal.fire({
    title: this.translate.instant('CONTRO_ENCU.COMFI_UPDA_TEX'),
    icon: 'warning',
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: this.translate.instant('CONTRO_ENCU.BTN_ACEP'),
    cancelButtonText: this.translate.instant('CONTRO_ENCU.BTN_CANC'),
  }).then((result) => {
    if (result.value) {
      let datos={
        surveyToken: element.token_config,
        opcion: opcion,
        correo: localStorage.getItem("user_padre")
      }
      console.log("datos",datos);

      this.modalGuardado();
      this.controlSurvey.updateFlagControlSurvey(datos).subscribe((respuesta: any) => {
        console.log("Respuestas ReporteExcel",respuesta);
        this.dataSource.data[index].ReporteExcel=event;
        Swal.close();
        this.openSuccessSnackBar(this.translate.instant('CONTRO_ENCU.TEX_SUCC_MOD_UPTD'),'');
      }, error => {
      console.log("error", error);
      });


    }else{
      this.dataSource.data[index].ReporteExcel=!event;
    }
    console.log('this.dataSource',this.dataSource);

  });


  }

online(event: any,element:any,index:number, opcion:number){
  Swal.fire({
    title: this.translate.instant('CONTRO_ENCU.COMFI_UPDA_TEX'),
    icon: 'warning',
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: this.translate.instant('CONTRO_ENCU.BTN_ACEP'),
    cancelButtonText: this.translate.instant('CONTRO_ENCU.BTN_CANC'),
  }).then((result) => {
    if (result.value) {
      let datos={
        surveyToken: element.token_config,
        opcion: opcion,
        correo: localStorage.getItem("user_padre")
      }
      this.modalGuardado();
      this.controlSurvey.updateFlagControlSurvey(datos).subscribe((respuesta: any) => {
        console.log("Respuestas Online",respuesta);
        this.dataSource.data[index].Online=event;
        Swal.close();
        this.openSuccessSnackBar(this.translate.instant('CONTRO_ENCU.TEX_SUCC_MOD_UPTD'),'');
      }, error => {
      console.log("error", error);
      });


    }else{
      this.dataSource.data[index].Online=!event;
    }
    console.log('this.dataSource',this.dataSource);

  });


}

offline(event: any,element:any,index:number, opcion:number){
  Swal.fire({
    title: this.translate.instant('CONTRO_ENCU.COMFI_UPDA_TEX'),
    icon: 'warning',
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: this.translate.instant('CONTRO_ENCU.BTN_ACEP'),
    cancelButtonText: this.translate.instant('CONTRO_ENCU.BTN_CANC'),
  }).then((result) => {
    if (result.value) {
      let datos={
        surveyToken: element.token_config,
        opcion: opcion,
        correo: localStorage.getItem("user_padre")
      }
      this.modalGuardado();
      this.controlSurvey.updateFlagControlSurvey(datos).subscribe((respuesta: any) => {
        console.log("Respuestas Offline",respuesta);
        this.dataSource.data[index].Offline=event;
        Swal.close();
        this.openSuccessSnackBar(this.translate.instant('CONTRO_ENCU.TEX_SUCC_MOD_UPTD'),'');
      }, error => {
      console.log("error", error);
      });


    }else{
      this.dataSource.data[index].Offline=!event;
    }
    console.log('this.dataSource',this.dataSource);

  });
}

AuditoriaUpd(event: any,element:any,index:number, opcion:number){
  Swal.fire({
    title: this.translate.instant('CONTRO_ENCU.COMFI_UPDA_TEX'),
    icon: 'warning',
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: this.translate.instant('CONTRO_ENCU.BTN_ACEP'),
    cancelButtonText: this.translate.instant('CONTRO_ENCU.BTN_CANC'),
  }).then((result) => {
    if (result.value) {
      let datos={
        surveyToken: element.token_config,
        opcion: opcion,
        correo: localStorage.getItem("user_padre")
      }
      this.modalGuardado();
      this.controlSurvey.updateFlagControlSurvey(datos).subscribe((respuesta: any) => {
        console.log("Respuestas Offline",respuesta);
        this.dataSource.data[index].Auditoría=event;
        Swal.close();
        this.openSuccessSnackBar(this.translate.instant('CONTRO_ENCU.TEX_SUCC_MOD_UPTD'),'');
      }, error => {
      console.log("error", error);
      });


    }else{
      this.dataSource.data[index].Auditoría=!event;
    }
    console.log('this.dataSource',this.dataSource);

  });
}

abreModal(historial){
  $(document).ready(function(){
  $("p").hover(function(){
    $(this).css("background-color", "gold");
    }, function(){
    $(this).css("background-color", "salmon");
  });
});
  console.log('historial',historial);


}

modalGuardado(){
  Swal.fire({
    title: this.translate.instant('CONTRO_ENCU.TEX_MOD_UPTD'),
    allowOutsideClick: false,
    showConfirmButton: false,
    imageUrl: localStorage.getItem('urlGifBroker'),
    imageWidth: 100,
    imageHeight: 60,
  });
}

openSuccessSnackBar(message: string, action: string) {
   this.snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['background-success']
   });
}


}
